const state = () => ({
  lastCacheClear: {
    pages: []
  }
})

const inBrowser = () => typeof window !== 'undefined'

const actions = {
  checkRateLimit: function({ rootGetters }, payload) {
    // Send a GET request with the current page with X-SSR-Force-Refresh header set.
    if (!rootGetters['user/isLoggedIn']) {
      throw new Error(`Error: You must be logged in to request a Cache Reset`)
    }
    if (payload !== undefined && payload.bypass) {
      return Promise.resolve(true)
    }

    return rootGetters['getGraphQLClient']().query({
      query: `query checkCacheResetRateLimit { ratelimit(name: "cacheReset") }`,
      opName: 'checkCacheResetRateLimit'
    })
      .then(response => {
        if (response.errors) {
          if (response.errors[0].category === 'ratelimit-exceeded') {
            return false
          }
          else {
            throw new Error('response.errors[0].message')
          }
        }
        return response.data.ratelimit
      })
  },

  SSRPageCacheClear: function({ rootState, rootGetters }, payload) {
    // Send a GET request with the current page with X-SSR-Force-Refresh header set.
    if (!rootGetters['user/isLoggedIn']) {
      throw new Error(`Error: You must be logged in to request a Cache Reset`)
    }
    return fetch(`${window.location.origin}${window.location.pathname}${window.location.search}`,
      {
        method: 'GET',
        headers: {
          'X-SSR-Force-Refresh': 1,
          Authorization: `Bearer ${rootState.user.authJWT}`
        }
      })
      .then(resp => {
        if (resp.ok) {
          return true
        }
        throw new Error(`Error: SSR Page Cache clear failed: ${resp.status} - ${resp.statusText}`)
      })
  },

  clearDrupalCaches: function({ rootState, rootGetters }) {
    // Send a REST request to the backend to clear the Drupal Caches - Authentication required.
    if (!rootGetters['user/isLoggedIn']) {
      throw new Error(`Error: You must be logged in to request a Cache Reset`)
    }
    return fetch(`${window.location.origin}/vuejs/cache-clear/drupal`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${rootState.user.authJWT}`
        }
      })
      .then(resp => {
        if (resp.ok) {
          return true
        }
        throw new Error(`Error: Drupal Cache clear failed: ${resp.status} - ${resp.statusText}`)
      })
  },

  clearVueJSCaches: function({ rootState, rootGetters }) {
    if (!rootGetters['user/isLoggedIn']) {
      throw new Error(`Error: You must be logged in to request a Cache Reset`)
    }
    // Send a REST request to the backend to clear the Drupal Redis Caches used by VueJS.
    return fetch(`${window.location.origin}/vuejs/cache-clear/vincreative`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${rootState.user.authJWT}`
        }
      })
      .then(resp => {
        if (resp.ok) {
          return true
        }
        throw new Error(`Error: VueJS Cache Clear failed: ${resp.status} - ${resp.statusText}`)
      })
  },
  SSRPurgeSiteCaches: function({ rootGetters, rootState }) {
    if (!rootGetters['user/isLoggedIn']) {
      throw new Error(`Error: You must be logged in to request a Cache Reset`)
    }
    // Makes a special request to the SSR for the current page with the 'X-SSR-Clear-Site-Pages header
    // that will force the ssr to clear all pages from the Redis Caches.
    if (inBrowser()) {
      return fetch(window.location.origin, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${rootState.user.authJWT}`,
          'X-SSR-Site-Cache-Reset': window.location.host
        }
      })
        .then(resp => {
          if (resp.ok) {
            return true
          }
          throw new Error(`Error: SSR Site Reset failed: ${resp.status} - ${resp.statusText}`)
        })
    }
    else {
      throw new Error(`Error: SSR Site Reset failed onl function in a WQeb Browser`)
    }
  }
}

export default {
  namespaced: true,
  state,
  actions
}
